import React from 'react';

import { CustomizedTabs } from 'components/common/CustomizedTabs/CustomizedTabs';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';

import { DistributionGraph } from 'components/widgets/DistributionGraph/DistributionGraph';
import { RiskRegister } from 'components/widgets/RiskRegister/RiskRegister';
import { useRiskRegisterTabsLogic } from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.logic';
import classes from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.module.scss';

export const RiskRegisterTabs = () => {
    const { logic } = useRiskRegisterTabsLogic();

    return (
        <>
            <CustomizedTabs<'table' | 'chart'>
                tabs={logic.tabsList}
                activeTab={logic.activeTab}
                setActiveTab={logic.setActiveTab}
            />
            <div className={classes.container}>
                <PageWidgetWrapper>
                    <RiskRegister activeTab={logic.activeTab} />
                    <DistributionGraph activeTab={logic.activeTab} />
                </PageWidgetWrapper>
            </div>
        </>
    );
};
